import { MessageService } from '../../services/message.service';
import { Component, OnInit } from '@angular/core';
import { Ship } from '../../Ship';
import { EntitlementService } from '../../services/entitlement.service';
import { ShipService } from '../../services/ship.service';
import { UserAuthInfoService } from 'src/app/services/user-auth-info.service';

@Component({
  selector: 'app-access-details',
  templateUrl: './access-details.component.html',
  styleUrls: ['./access-details.component.css']
})
export class AccessDetailsComponent implements OnInit {
  ship: Ship;
  shipResultArray: Ship[];
  passwords = 'false';
  shipPasswordSpinner: string;
  shipPassword: any[];
  spellingList0: any;
  spellingList1: any;
  spellingList2: any;
  endUserAgreement: string;
  showSpellingError = false;
  timeLeft: number;
  timeOrig: number;
  interval;
  daysLeft: any;
  datePass: Date;
  passMonth: any;
  passDay: any;
  passYear: any;
  pwd_change_threshold = 60;
  webSerStatus:any;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private messageService: MessageService,
    private userAuthInfoService: UserAuthInfoService
  ) { }

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
  }

  showPassword() {
    this.passwords = 'true';
    this.shipPasswordSpinner = 'fa fa-spinner fa-spin fa-4x';
    this.shipService.insertAuditMessage(this.ship.shipLocation).subscribe(
      () => {
        this.shipService.getShipPasswords(this.ship.shipLocation).subscribe(
          (data: any[]) => {
            this.shipPasswordSpinner = '';
            this.shipPassword = data;
            if (this.shipPassword[0] === undefined) {
              this.showSpellingError = true;
              return;
            }
            this.spellingList0 = this.userAuthInfoService.getPhoneticSpelling(this.shipPassword[0].password);
            this.spellingList1 = this.userAuthInfoService.getPhoneticSpelling(this.shipPassword[1].password);
            this.spellingList2 = this.userAuthInfoService.getPhoneticSpelling(this.shipPassword[2].password);
            this.timeLeft = this.shipPassword[0].timeoutLength;
            this.timeOrig = this.shipPassword[0].timeoutLength;
            this.daysLeft = this.shipPassword[0].passwordDaysRemain;
            this.webSerStatus = this.shipPassword[0].merStatus;
            this.calculateDate();
            this.startTimer();
          },
          error => {
            if (error.error) {
              this.messageService.error(error.error);
            } else {
              this.messageService.error('Could not retrieve passwords');
            }

            this.showSpellingError = true;
            this.shipPasswordSpinner = '';
          }
        );
      }
    );
  }

  hidePasswords() {
    this.passwords = 'false';
    clearInterval(this.interval);
    this.timeLeft = this.timeOrig;
  }

  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.hidePasswords();
      }
    },1000)
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  isLocked(){
    if(this.webSerStatus === 'LOCKED'){
      return true;
    }else{
      return false;
    }
  }


  unlockStatus(){
    this.shipService.getUnlock(this.ship.shipLocation).subscribe(
      (response) => {this.messageService.success("Successfully Unlocked")},
      (error) => {this.messageService.error("Error Occured while Unlocking")}
    );
    this.hidePasswords();
    this.showPassword();
  }

  calculateDate() {
    this.datePass = new Date();
    let days = this.pwd_change_threshold - this.daysLeft;

    this.datePass.setDate(this.datePass.getDate() - days);
    this.passDay = this.datePass.getDate();
    this.passMonth = this.datePass.getMonth() + 1;
    this.passYear = this.datePass.getFullYear();

    if (this.passMonth < 10) {
      this.passMonth = "0" + this.passMonth;
    }

    if (this.passDay < 10) {
      this.passDay = "0" + this.passDay;
    }
  }

}
